module.exports = __webpack_public_path__ + "static/media/workingmemory-words-5.28f0b181.mp3";